import React from 'react'
import TransferOrder from './TransferOrder'

export default function TransferOrderEx() {
  return (
    <>
      <TransferOrder data={{isBigOrder:true,handleEditAuthority:{orderStatus: [1,2]},handleDelectAuthority:{orderStatus: [1,2]}}}></TransferOrder>
     </>
  )
}
